import React from 'react';
import { useTranslation } from 'react-i18next';
import ReviewCardWrapper from 'router/subrouters/Dashboard/components/ReviewCardWrapper';
import useCard from './hooks/useCard';

const SubscriptionCard: React.FC = () => {
  const { t } = useTranslation();

  const list = useCard();

  return <ReviewCardWrapper list={list} title={t('subscriptionCardTitle')} />;
};

export default SubscriptionCard;
